import React from 'react'
import { CheckIcon, XIcon } from '../SvgIcons/SvgIcons'
import { Rate } from 'antd'


const BountyCompleted = ({completeOffer, myBounty}) =>  {
    return (
        <div className="bounty-offer-card bounty-completed">
            <div className="feed-card-wrapper">
                <div>
                    <div className="row m-0 justify-content-between">
                        <h2 className="heading">{completeOffer?.bountyId?.bountyType === 'company' ? myBounty?.company : myBounty?.fullName}</h2>
                        <h2 className="small-heading">${myBounty?.demandPrice}</h2>
                    </div>
                    <p>{myBounty?.title} at The {myBounty?.company}</p>
                    <span>For {myBounty?.reason}</span>
                </div>  
            </div>
            <div className="offer-card-top">
                <h2 className="small-heading">@{completeOffer?.introPerson?.firstName}{completeOffer?.introPerson?.lastName}</h2>
                {/* <Rate style={{ color: "#000" }} /> */}
            </div>
            <div className="delivery-info-wrap">
                <div className="info-wrap">
                    <span>Relationship</span>
                    <h3 className="paragraph">{completeOffer?.relation}</h3>
                </div>
                <div className="info-wrap">
                    <span>Deliver by</span>
                    <h3 className="paragraph">Intro {completeOffer?.introTime}</h3>
                </div>
                <div className="info-wrap col p-0">
                    <span>Comments</span>
                    <h3 className="paragraph">{completeOffer?.comment}</h3>
                </div>
            </div>
            <div className="rate-box">
                <h3 className="small-heading">Rate {completeOffer?.introPerson?.firstName}{completeOffer?.introPerson?.lastName}</h3>
                <Rate style={{ color: "#000" }} value={completeOffer?.introPerson?.rating} />
            </div>
            <div className="btn-row">
                <button className="btn-style" >Bounty completed</button>
            </div>
        </div>
    )
}

export default BountyCompleted;